module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-m"
  }, [_c('div', [_c('div', [_c('h1', [_vm._v("Hi There!")]), _vm._v(" "), _c('p', [_vm._v("Please login or register an account to continue with your purchase.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    staticClass: "button-type-h",
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    staticClass: "button-type-h",
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "to": "/registration/buyer"
    }
  }, [_vm._v("Register")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2be76b5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MembershipNotification.vue
// module id = 144
// module chunks = 0